import {useRef, useEffect} from 'external/react'
import {
  Box
 ,Fade
 ,Table 
 ,TableContainer 
 ,TableBody 
 ,TableRow 
 ,TableCell 
} from 'external/material'

import GradebookDetailsHead from './GradebookDetailsHead'

import useStudentContext from 'hooks/student'
import useTranslations from 'hooks/translations'

export default function GradebookDetails(props) {

  const {translate} = useTranslations()
  const {grades} = useStudentContext()
  const {formatDate} = useTranslations()
  const [firstGrade] = grades

  const loaded = firstGrade && firstGrade.clique == props.group.id
 
  return (
    <Box className="grades">
      <TableContainer className="gradesTableContainer">
        <Table className="gradesTable">
          <GradebookDetailsHead />
          <Fade in={loaded} timeout={{enter: 500}}>
          <TableBody>
            {loaded && (grades.map((grade, i) => {
              return (<TableRow key={i}>
                <TableCell className="nameCell" align="left">
                  <span className="date">{formatDate(grade.date)}</span>
                </TableCell>
                <TableCell align="left">
                  <span className="gradeName">{translate(grade.type)}</span>
                </TableCell>
                <TableCell align="left">
                  <span className="gradeName">{grade.name}</span>
                </TableCell>
                <TableCell align="left">
                  <span className="gradeName">{grade.term}</span>
                </TableCell>
                <TableCell align="left">
                  <span className={"points"}>{grade.points} / {grade.total}</span>
                </TableCell>
                <TableCell align="center">
                  <span className="actions"></span>
                </TableCell>          
              </TableRow>)
            }))}
          </TableBody>
          </Fade>
        </Table>
      </TableContainer>
    </Box>

  )
}
